import React, { useRef } from "react";
import instance from "../../../api/api";
import { styleIcone } from "../../../shared";
import { IoMdEye } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import { MenuPoint } from "../../../shared/compoments";
import { lienImage } from "../../../api/api";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabView, TabPanel } from "primereact/tabview";
import { Help } from "../../../utils";

function ProprieteDatatable({
  items,
  itemsForFilter,
  filters,
  disponibleOrIndisponible,
  getListBiens,
}) {
  const dt = useRef(null);
  const options = [
    {
      name: "Voir plus",
      path: "/biens-detail/",
      icone: <IoMdEye style={styleIcone} />,
      isIdData: true,
    },
    {
      name: `Rendre ${disponibleOrIndisponible}`,
      icone: <FiPlus style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      methode: (idData) => {
        renderIndisponibleBiens(idData, disponibleOrIndisponible);
      },
    },
  ];

  const renderIndisponibleBiens = async (id, textStatut) => {
    try {
      const response = await instance.post("modifProprieties/" + id, {
        statut: textStatut,
      });
      console.log(response);
      if (response["status"] === 200) {
        const index = items.findIndex((item) => item.id === id);
        items.splice(index, 1);
        getListBiens();
        console.log(items);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const detailsInfo = (rowData) => {
    return (
      <MenuPoint
        optionMenu={options}
        idData={rowData.id}
        statut={rowData.statut}
      />
    );
  };
  const handlePrix = (rowData) => {
    return <p>{Help.convertInMoney(rowData.cost)}</p>;
  };

  const getImage = (rowData) => {
    return (
      <img
        src={lienImage + rowData?.photos[0]?.path}
        className="photo_style"
        alt={rowData?.photos[0]?.path}
      />
    );
  };

  return (
    <div className="px-3">
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={itemsForFilter}>
            <Column
              field="nom"
              style={{ textAlign: "center" }}
              header="Bien"></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Image"
              body={getImage}></Column>
            <Column
              field="type.label"
              style={{ textAlign: "center" }}
              header="Type"></Column>
            <Column
              field="type.category.label"
              style={{ textAlign: "center" }}
              header="Catégorie"></Column>

            <Column
              field="cost"
              style={{ textAlign: "center" }}
              header="Prix (Fcfa)"
              body={handlePrix}></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Actions"
              body={detailsInfo}></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}
export default ProprieteDatatable;
